import { FilterOperatorType } from '../../shared/components/odata-filter/models/filter-operator-type';

export interface AiPeopleFilterRule {
  displayName?: string;
  fieldId?: string;
  operator: FilterOperatorType;
  value?: string;
  values?: string[];
  subFilters?: AiPeopleFilterRule[];
}

export interface AiFilterGroup {
  logic: 'and' | 'or';
  rules: (AiPeopleFilterRule | AiFilterGroup)[];
}

export function isFilterGroup(r: AiPeopleFilterRule | AiFilterGroup): r is AiFilterGroup {
  return (r as AiFilterGroup).logic !== undefined;
}

export interface AiPeopleOrderByRule {
  field: string;
  dir: 'asc' | 'desc';
}

export interface AiPeopleQueryIntent {
  entity: string;
  filter: AiFilterGroup;
  orderBy: AiPeopleOrderByRule[];
  top?: number;
  skip?: number;
  explanation: string;
}

export interface AiQuotaInfo {
  used: number;
  limit: number;
  resetsAtUtc: string;
  usedPercent: number;
  isDisabled: boolean;
  isExhausted: boolean;
}
